/**
 * pt-BR — Portuguese (Brazil) stub.
 *
 * Intentionally partial. Only high-traffic surfaces are translated for now
 * (nav, auth, notifications, common actions). Missing keys fall back to
 * en-US at runtime via i18next's `fallbackLng`, so adding a locale never
 * breaks a page — it just shows English until a translator fills it in.
 */
import type enUS from "./en-US";

type EnResources = typeof enUS;
type DeepPartial<T> = { [K in keyof T]?: T[K] extends object ? DeepPartial<T[K]> : T[K] };

const ptBR: DeepPartial<EnResources> = {
  nav: {
    dashboard: "Painel",
    people: "Pessoas",
    timeOff: "Folgas",
    timeTracking: "Ponto",
    invoices: "Faturas",
    approvals: "Aprovações",
    recruiting: "Recrutamento",
    performance: "Desempenho",
    assets: "Ativos",
    complaints: "Reclamações",
    documents: "Documentos",
    reports: "Relatórios",
    aiAssistant: "Assistente IA",
    settings: "Configurações",
    primary: "Principal",
    expandSidebar: "Expandir menu",
    collapseSidebar: "Recolher menu",
    securityMfa: "Segurança e MFA",
    logout: "Sair",
  },
  common: {
    loading: "Carregando…",
    save: "Salvar",
    cancel: "Cancelar",
    delete: "Excluir",
    edit: "Editar",
    close: "Fechar",
    search: "Buscar",
    language: "Idioma",
    timezone: "Fuso horário",
    currency: "Moeda",
    accessDenied: "Acesso negado",
    accessDeniedBody: "Você não tem permissão para ver esta página.",
    retry: "Tentar novamente",
    noResults: "Nenhum resultado",
  },
  auth: {
    welcomeBack: "Bem-vindo de volta",
    signInSubtitle: "Entre na sua conta",
    tagline:
      "A plataforma de RH inteligente que sua equipe realmente quer usar. Gerencie pessoas, tempo e cultura — tudo em um só lugar.",
    demoHint: "Demo: admin@acme.com / demo1234",
    signIn: "Entrar",
    email: "E-mail",
    password: "Senha",
    forgotPassword: "Esqueceu a senha?",
    rememberMe: "Lembrar de mim",
  },
  notifications: {
    title: "Notificações",
    markAllRead: "Marcar todas como lidas",
    empty: "Nenhuma notificação ainda.",
    justNow: "agora mesmo",
    minutesAgo: "há {{count}}m",
    hoursAgo: "há {{count}}h",
    daysAgo: "há {{count}}d",
    unreadCountLabel: "Notificações, {{count}} não lidas",
    unreadPrefix: "Não lida: {{title}}",
  },
  search: {
    placeholder: "Buscar pessoas, documentos, tarefas…",
    groups: {
      pages: "Páginas",
      people: "Pessoas",
      documents: "Documentos",
      tasks: "Tarefas",
    },
  },
  settings: {
    preferences: "Preferências",
    preferencesHint:
      "Idioma, fuso horário e moeda usados em todo o aplicativo.",
    languageLabel: "Idioma",
    timezoneLabel: "Fuso horário",
    currencyLabel: "Moeda de exibição",
  },
};

export default ptBR;
